import PAGOS_SOLICITUDES from '@/graphql/querys/administracion/pagos/pagosSolicitudes.gql';

export default {
  apollo: {
    pagosSolicitudes: {
      query: PAGOS_SOLICITUDES,
    },
  },
  methods: {
    getPagosElemento(id, fechaAl) {
      return this.mixGetSolicitud(id, fechaAl);
    },
    mixGetSolicitud(item, fechaAl) {
      if (!this.getPagosSolicitudes) return {};
      const solicitudDetalle = [...this.getPagosSolicitudes
        .filter(({ fecha }) => new Date(`${fecha} 00:00:0`) <= new Date(`${fechaAl} 00:00:0`))
        .map((solicitud) => solicitud.detalles)]
        .flat(1)
        .find((pagoSolicitudDetalle) => pagoSolicitudDetalle.idReferencia === item);
      /*
      let solicitudDetalle = this.getPagosSolicitudesDetalles
        .find((pagoSolicitudDetalle) => pagoSolicitudDetalle.idReferencia === item);
*/
      if (!solicitudDetalle) {
        return ({
          total: 0,
          detalle: '',
        });
      }
      const solicitud = this.getPagosSolicitudes.find(
        (pagoSolicitud) => pagoSolicitud.id === solicitudDetalle.idPagosSolicitud,
      );
      return ({
        total: '',
        detalle: `${this.$moment(solicitud.fecha).format('D/MM/YYYY')} - ${solicitud.folio}`,
      });
    },
    mixGetSolicitudDetalles(item) {
      const solicitud = this.getPagosSolicitudesDetalles.find(
        (pagoSolicitud) => pagoSolicitud.idReferencia === item.id,
      );
      return solicitud || null;
    },
  },
  computed: {
    getPagosSolicitudes() {
      if (!this.pagosSolicitudes) return [];
      return this.pagosSolicitudes;
    },
    getPagosSolicitudesDetalles() {
      if (!this.getPagosSolicitudes) return [];
      const solicitudesDetalles = [];
      this.getPagosSolicitudes.forEach((solicitud) => {
        solicitudesDetalles.push(...solicitud.detalles);
      });
      return solicitudesDetalles;
    },
  },
};
